import { atom } from "@mongez/react-atom";
import type { FAQ } from "../types";

export const faqAtom: any = atom<FAQ[]>({
  key: "faq",
  default: [],
});
